/**
 * The audit module's routes, owned by the feature.
 *
 * D5 says a feature exports its own routes and `app/router.tsx` composes them. **Both halves are
 * true since T71 closed F-069**: this array is the feature's, and `src/app/router.tsx` spreads it.
 *
 * The array shape is what made that swap cost nothing when it happened.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

/*
 * `AuditPage`, not `AuditLogsPage`, since T23: the audit screen is now a tab strip over the log and
 * the statistics panel. Still ONE route — see `AuditPage.tsx` for why the panel is a tab rather
 * than the second route the ticket asked for.
 */
const AuditPage = lazy(() => import('./AuditPage'));

export const auditRoutes: RouteObject[] = [{ path: 'audit', element: <AuditPage /> }];
